import { ContainerComponent } from 'AppReact';
import { Icon, ViewText } from './atoms';
import { FlexCenterWrapper } from 'wrappers';
import { ListColsSvg, ListRowSvg, ListGridSvg } from 'components/icons';
import internalState from './internalState';
import controller from './controller';

export const definition = {
  name: 'ViewSwitch',
  controller,
  initialProps: ({ view, display }) => ({ view, display }),
  props: internalState,
  elements: [
    {
      wrapper: FlexCenterWrapper,
      name: 'Wrapper',
      elements: [
        {
          component: ViewText,
          name: 'ViewText',
          displayValue: ({ }) => 'View:',
        },
        {
          component: Icon,
          name: 'Table',
          renderIf: ({ display }) => !display || display?.length === 0 || display.includes('table'),
          displayValue: ({ view }) => ListRowSvg({ selected: view === 'table' }),
          bindings: ({ }) => ({})
        },
        {
          component: Icon,
          name: "List",
          renderIf: ({ display }) => !display || display?.length === 0 || display.includes('list'),
          displayValue: ({ view }) => ListColsSvg({ selected: view === 'list' }),
          bindings: ({ }) => ({})
        },
        {
          component: Icon,
          name: "Grid",
          renderIf: ({ display }) => display?.includes('grid'),
          displayValue: ({ view }) => ListGridSvg({ selected: view === 'grid' }),
          bindings: ({ }) => ({})
        },
      ]
    }
  ]
}

export default ContainerComponent(definition);